import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream" data-id="element-44" data-mp="1lcafxcu66n62">
      <div className="mx-auto max-w-3xl px-6 py-16 lg:py-24" data-id="element-45" data-mp="1gcpg7076easa">
        <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-46" data-mp="1geimgedvmszr">
          Preguntas frecuentes
        </h2>

        <div className="mt-10 border-t border-ink/10" data-id="element-47" data-mp="291mk1yan451i">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="border-b border-ink/10" data-id="element-48" data-mp="240p3fq5a3j24" data-mpi={i}>
                <h3 data-id="element-49" data-mp="1z3ynd2th4ngp">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-50" data-mp="1z2dvxm2ghkn2">
                    <span className="font-medium text-ink" data-id="element-51" data-mp="fk0bwt72tyzp">{faq.q}</span>
                    <PlusIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-teal transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-45' : ''}`} data-id="element-52" data-mp="fm4ftb4z6xzz" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-53" data-mp="3sywmxyjrhyah">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-54" data-mp="1sd5w1nc1c3q">
                      <p className="pb-6 pr-10 text-base leading-relaxed text-ink/70" data-id="element-55" data-mp="1pq4ekbcn7us6">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}